export default "__VITE_ASSET__bSfp2I4t__"